import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles/createTheme';
import { MAX_PAGE_WIDTH } from '../../../styles/constants';

export const useStyles = makeStyles<Theme>()((theme) => ({
  headerWrapper: {
    backgroundColor: theme.palette.background.paper,
    height: theme.spacing(8),
    borderRadius: '0 0 5px 5px',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    boxShadow: `0 4px 6px rgba(0, 0, 0, 0.1)`,
    zIndex: 1000,
  },

  headerContent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    maxWidth: MAX_PAGE_WIDTH,
    width: '100%',
    padding: theme.spacing(2),
    gap: theme.spacing(2),
  },

  leftPart: {
    display: 'flex',
    alignItems: 'center',
  },

  menuIcon: {},
  searchWrapper: {
    maxWidth: '600px',
    width: '100%',
  },

  globalSearch: {
    width: '100%',
  },

  rightPart: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
}));
